import withSpacing from '../../decorators/withSpacing/index';
import ThemeContainer from './ThemeContainer';
export default withSpacing(ThemeContainer);
//# sourceMappingURL=index.js.map